import React, { FC, ReactNode } from 'react';
import { CssBaseline } from '@mui/material';
import { createTheme, styled, ThemeProvider } from '@mui/material/styles';

import Header from 'src/components/Header';
import Footer from 'src/components/Footer';
import SEO from 'src/components/SEO';
import GlobalStyles from 'src/styles/GlobalStyles';
import GlobalFont from 'src/styles/GlobalFont';
import { Helmet } from 'react-helmet';

const theme = createTheme({
  components: {
    MuiContainer: {
      styleOverrides: {
        maxWidthLg: {
          maxWidth: '1440px !important',
        },
        root: {
          paddingLeft: 24,
          paddingRight: 24,
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        'spacing-xs-5': {
          margin: -20,
          '& > .MuiGrid-item': {
            padding: 20,
          },
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#00dd99',
    },
  },
  typography: {
    fontFamily: [
      'BrandonTextOfficeRegular',
      'BrandonTextOfficeBold',
      'Noto Sans KR',
      'sans-serif',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
});

const Main = styled('main')(({ theme }) => ({
  marginTop: 200,

  [theme.breakpoints.up('md')]: {
    marginTop: 250,
  },
}));

const Layout: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalFont />
      <GlobalStyles />
      <CssBaseline />
      <SEO />
      <Header />
      <Main>{children}</Main>
      <Footer />
    </ThemeProvider>
  );
};

export default Layout;
